import React from "react";
import "./EditorToolbar.css";
import aiImage from "../../../assets/icon/editorLogo.svg"
// import aiImage from "../img/logo2small.svg"
const EditorToolbar = ({
  fontFamily,
  setFontFamily,
  fontSize,
  setFontSize,
  onInsertBlock,
  isAiProcessing,
  hasUnsavedChanges,
  aiStatus,
  showChat,
  setShowChat,
  onCopyText,
  onDownloadDocx,
  onUndo,
  onRedo,
  canUndo,
  canRedo,
  copyButtonText,
  onEditorJsDownloadSave,
  onEditorJsSave,
}) => {
  const allowedFontSizes = [
    8, 9, 10, 11, 12, 14, 16, 18, 24, 30, 36, 48, 60, 72, 96,
  ];

  const handleIncrementFontSize = () => {
    const current = Number(fontSize);
    const currentIndex = allowedFontSizes.indexOf(
      Number.isNaN(current) ? 16 : current
    );
    const safeIndex =
      currentIndex === -1 ? allowedFontSizes.indexOf(16) : currentIndex;
    const nextIndex = Math.min(allowedFontSizes.length - 1, safeIndex + 1);
    setFontSize(String(allowedFontSizes[nextIndex]));
  };

  const handleDecrementFontSize = () => {
    const current = Number(fontSize);
    const currentIndex = allowedFontSizes.indexOf(
      Number.isNaN(current) ? 16 : current
    );
    const safeIndex =
      currentIndex === -1 ? allowedFontSizes.indexOf(16) : currentIndex;
    const prevIndex = Math.max(0, safeIndex - 1);
    setFontSize(String(allowedFontSizes[prevIndex]));
  };
  return (
    <div className="editor-toolbar">
      {/* Font Family Dropdown - Note: This affects CSS, not EditorJS content directly */}
      <select
        value={fontFamily}
        onChange={(e) => setFontFamily(e.target.value)}
        className="editor-toolbar-select editor-toolbar-font-family"
        title="Font Family (affects display only)"
      >
        <option value="Calibri">Calibri</option>
        <option value="Arial">Arial</option>
        <option value="Times New Roman">Times New Roman</option>
        <option value="Verdana">Verdana</option>
        <option value="Georgia">Georgia</option>
        <option value="Courier New">Courier New</option>
      </select>

      {/* Font Size Controls - Note: Affects CSS, not EditorJS content */}
      <div className="editor-toolbar-font-size-group">
        <button
          type="button"
          className="editor-toolbar-button"
          onClick={handleDecrementFontSize}
          title="Decrease font size"
          aria-label="Decrease font size"
        >
          <i class="bi bi-dash"></i>
        </button>
        <select
          value={fontSize}
          onChange={(e) => setFontSize(e.target.value)}
          className="editor-toolbar-select editor-toolbar-font-size"
          title="Font Size (affects display only)"
        >
          {allowedFontSizes.map((size) => (
            <option key={size} value={size}>
              {size}
            </option>
          ))}
        </select>
        <button
          type="button"
          className="editor-toolbar-button"
          onClick={handleIncrementFontSize}
          title="Increase font size"
          aria-label="Increase font size"
        >
          <i class="bi bi-plus"></i>
        </button>
      </div>

      {/* EditorJS Block Type Buttons */}
      <div className="editor-toolbar-section">
        <button
          onClick={() => onInsertBlock("header", { text: "", level: 1 })}
          className="editor-toolbar-button"
          title="Insert Header"
          disabled={isAiProcessing}
        >
          <i className="bi bi-type-h1"></i>
        </button>
        <button
          onClick={() => onInsertBlock("header", { text: "", level: 2 })}
          className="editor-toolbar-button"
          title="Insert Subheader"
          disabled={isAiProcessing}
        >
          <i className="bi bi-type-h2"></i>
        </button>
        <button
          onClick={() => onInsertBlock("paragraph", { text: "" })}
          className="editor-toolbar-button"
          title="Insert Paragraph"
          disabled={isAiProcessing}
        >
          <i className="bi bi-paragraph"></i>
        </button>
      </div>

      {/* List and Structure Buttons */}
      <div className="editor-toolbar-section">
        <button
          onClick={() =>
            onInsertBlock("list", { style: "unordered", items: [""] })
          }
          className="editor-toolbar-button"
          title="Insert Bullet List"
          disabled={isAiProcessing}
        >
          <i className="bi bi-list-ul"></i>
        </button>
        <button
          onClick={() =>
            onInsertBlock("list", { style: "ordered", items: [""] })
          }
          className="editor-toolbar-button"
          title="Insert Numbered List"
          disabled={isAiProcessing}
        >
          <i className="bi bi-list-ol"></i>
        </button>
        <button
          onClick={() =>
            onInsertBlock("checklist", {
              items: [{ text: "", checked: false }],
            })
          }
          className="editor-toolbar-button"
          title="Insert Checklist"
          disabled={isAiProcessing}
        >
          <i className="bi bi-check2-square"></i>
        </button>
      </div>

      {/* Special Content Buttons */}
      <div className="editor-toolbar-section">
        <button
          onClick={() => onInsertBlock("quote", { text: "", caption: "" })}
          className="editor-toolbar-button"
          title="Insert Quote"
          disabled={isAiProcessing}
        >
          <i className="bi bi-quote"></i>
        </button>
        <button
          onClick={() => onInsertBlock("code", { code: "" })}
          className="editor-toolbar-button"
          title="Insert Code Block"
          disabled={isAiProcessing}
        >
          <i className="bi bi-code-slash"></i>
        </button>
      </div>

      {/* Copy Text Button */}
      <div className="editor-toolbar-section">
        <button
          onClick={onCopyText}
          className="editor-toolbar-button"
          title="Copy all text to clipboard"
          disabled={isAiProcessing}
        >
          <i className="bi bi-clipboard"></i>
        </button>
      </div>

      {/* Download DOCX Button */}
      <div className="editor-toolbar-section">
        <button
          onClick={onDownloadDocx}
          className="editor-toolbar-button"
          title="Download document as DOCX"
          disabled={isAiProcessing}
        >
          <i className="bi bi-file-earmark-word"></i>
        </button>
      </div>

      <div className="editor-toolbar-section">
        <button
          onClick={onEditorJsDownloadSave}
          className="editor-toolbar-button"
          title="Download document as editorJs"
          disabled={isAiProcessing}
        >
          <i className=" fa fa-download"></i>
        </button>
      </div>

      <div className="editor-toolbar-section">
        <button
          onClick={onEditorJsSave}
          className="editor-toolbar-button"
          title="save document "
          disabled={isAiProcessing}
        >
          <i className=" fa-solid fa-save"></i>
        </button>
      </div>

      {/* Undo/Redo Buttons */}
      <div className="editor-toolbar-section">
        <button
          onClick={onUndo}
          className={`editor-toolbar-button ${
            !canUndo ? "editor-toolbar-button-disabled" : ""
          }`}
          disabled={!canUndo || isAiProcessing}
          title="Undo (Ctrl+Z)"
        >
          <i className="bi bi-arrow-counterclockwise"></i>
        </button>
        <button
          onClick={onRedo}
          className={`editor-toolbar-button ${
            !canRedo ? "editor-toolbar-button-disabled" : ""
          }`}
          disabled={!canRedo || isAiProcessing}
          title="Redo (Ctrl+Y)"
        >
          <i className="bi bi-arrow-clockwise"></i>
        </button>
      </div>

      {/* Status Indicators & Actions */}
      <div className="editor-toolbar-status">
        {/* AI Status Indicator */}
        {isAiProcessing && (
          <div className="d-flex align-items-center text-info editor-toolbar-ai-status">
            <div
              className="spinner-border spinner-border-sm me-2"
              role="status"
            >
              <span className="visually-hidden">Loading...</span>
            </div>
            AI is working...
          </div>
        )}

        {/* Unsaved Changes Indicator */}
        {hasUnsavedChanges && !isAiProcessing && (
          <span
            className="text-warning editor-toolbar-unsaved"
            title="You have unsaved changes"
          >
            <i className="bi bi-circle-fill me-1"></i>
            Unsaved
          </span>
        )}

        {/* AI Chat Toggle */}

        <button
          className={`editor-toolbar-action-button ${
            showChat ? "editor-toolbar-action-active" : ""
          }`}
          onClick={() => setShowChat((prev) => !prev)}
          title="Toggle AI Assistant Panel"
        >
          <i class="fa-solid fa-robot"></i>
        </button>

        {/* Connection Status */}
        {/* <span
          className={`editor-toolbar-status-badge ${
            aiStatus.includes("Error") || aiStatus.includes("Disconnected")
              ? "status-error"
              : aiStatus.includes("Processing")
              ? "status-processing"
              : "status-ready"
          }`}
        >
          {aiStatus}
        </span> */}
      </div>
    </div>
  );
};

export default EditorToolbar;
